/*********************** Custom JS for Boost AI Search & Discovery  ************************/

(function($) {
    //Scroll to the top after click a filter
    $(document).on('click', '.boost-pfs-filter-option-item, .boost-pfs-filter-clear', function(){ 
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    });

    //Fix search page pagination links missing query
    if ($('body').hasClass('template-search')) {
        const params = new window.URLSearchParams(window.location.search);
        const searchQuery = encodeURIComponent(params.get('q'));

        const onReadyDomElement = function(element, callback) {
            if (jQuery(element).length) {
              callback(jQuery(element));
            } else {
              setTimeout(function() {
                onReadyDomElement(element, callback);
              }, 100);
            }
        };
        
        if (searchQuery.length) {
            onReadyDomElement('.boost-pfs-filter-bottom-pagination li a', function(e) {

                e.each(function() {

                    let linkHref = $(this).attr('href');

                    if (linkHref.indexOf("page=") >= 0) {
                        linkHref = linkHref+'&q='+searchQuery;
                    } else {
                        linkHref = linkHref+'?q='+searchQuery;
                    }

                    $(this).attr('href', linkHref);

                });
            });
        }
    }

    $('.boost-pfs-filter-item-swatch li span').each(function () {
        $(this).click(function () {
            // add active class to selected option
            $(this)
                .parents('.boost-pfs-filter-item-swatch')
                .find('li')
                .removeClass('active-option')
            $(this)
                .parents('li')
                .addClass('active-option');

            // hide price-range for on sale variants
            $(this)
                .parents('.boost-pfs-filter-product-bottom')
                .find('.price-range')
                .addClass('hide');

        });

    });

  
})(jQuery);
